export default function useIntercom() {
	const { loadScript, scriptIsLoaded } = useScriptLoader()

	const openInterCom = () => {
		// @ts-ignore
		if (import.meta.client && window && window?.Intercom) {
			// @ts-ignore
			window.Intercom('show')
		}
	}

	const loadIntercom = () => {
		if (scriptIsLoaded.value) return
		loadScript('/js/intercom.js')
		loadScript('https://widget.intercom.io')

		// Cleanup listeners
		if (import.meta.client) {
			window.removeEventListener('scroll', loadIntercom)
			window.removeEventListener('touchstart', loadIntercom)
		}
	}

	onMounted(() => {
		if (import.meta.client) {
			// Load on scroll, touch or after 4s delay
			window.addEventListener('scroll', loadIntercom, { passive: true })
			window.addEventListener('touchstart', loadIntercom, { passive: true })
			const timeout = setTimeout(loadIntercom, 4000)

			onUnmounted(() => {
				window.removeEventListener('scroll', loadIntercom)
				window.removeEventListener('touchstart', loadIntercom)
				clearTimeout(timeout)
			})
		}
	})

	watch(
		scriptIsLoaded,
		loaded => {
			if (loaded) {
				const runtime = useRuntimeConfig()
				// @ts-ignore
				if (import.meta.client && window && typeof window.Intercom === 'function') {
					try {
						// @ts-ignore
						window.Intercom('boot', {
							app_id: runtime.public.intercomKey,
							hide_default_launcher: true,
							custom_launcher_selector: '#intercom_custom_btn'
						})
					} catch (error) {
						console.warn('Intercom boot suppressed due to initialization error', error)
					}
				}
			}
		},
		{ immediate: true }
	)
	return {
		openInterCom
	}
}
